import { useNavigate } from 'react-router-dom';
import { useTracking } from '../useTracking';

export const useGoBack = () => {
  const navigate = useNavigate();
  const { elementClickedEvent } = useTracking();

  const goBack = () => {
    elementClickedEvent({
      elementType: 'button/icon',
      text: 'go-back-unified',
      location: window.location.pathname,
    });

    if (window.history.length > 1 && document.referrer !== '') {
      return navigate(-1);
    } else {
      return navigate('..', { relative: 'path', replace: true });
    }
  };

  return { goBack };
};
